import { productpointlimitConstants }  from '../constants/productpointlimit.constants';
import { alertActions } from './alert.actions';
import resources from '../resources';
import ProductPointLimitService from '../services/productpointlimit.service';
 
export const productpointlimitActions = {  
    create,
    addorupdate,
    get,
    getById,
    update,
    remove
};
/**
 * Create object action
 * @param {*} data 
 */
function create(data) {
    return dispatch => {
        dispatch(request(data));

        return new ProductPointLimitService().create(data)
                        .then(
                            productpointlimit => {
                                dispatch(success(productpointlimit));
                                dispatch(alertActions.success(resources.SAVE_SUCCESS));
                                return productpointlimit;
                            },
                            error => {
                                dispatch(failure(error, data));
                                dispatch(alertActions.error(resources.SAVE_FAILED + ': ' + error));
                                return error;
                            }
                        );
    };

    function request(productpointlimit) { return { type: productpointlimitConstants.CREATE_PRODUCTPOINTLIMIT_REQUEST, productpointlimit } }
    function success(productpointlimit) { return { type: productpointlimitConstants.CREATE_PRODUCTPOINTLIMIT_SUCCESS, productpointlimit } }
    function failure(error, productpointlimit) { return { type: productpointlimitConstants.CREATE_PRODUCTPOINTLIMIT_FAILURE, error, productpointlimit } }
}
/**
 * Create object[] action
 * Add or update, based on Id, if  Id = 0, then create, else update
 * @param {*} data 
 */
function addorupdate(data) {
    return dispatch => {
        dispatch(request(data));

        return new ProductPointLimitService().addorupdate(data)
                        .then(
                            productpointlimits => {
                                dispatch(success(productpointlimits));
                                //dispatch(alertActions.success(resources.SAVE_SUCCESS));
                                return productpointlimits
                            },
                            error => {
                                dispatch(failure(error, data));
                                dispatch(alertActions.error(resources.SAVE_FAILED + ': ' + error));
                                return error;
                            }
                        );
    };

    function request(productpointlimits) { return { type: productpointlimitConstants.ADDORUPDATE_PRODUCTPOINTLIMITS_REQUEST, productpointlimits } }
    function success(productpointlimits) { return { type: productpointlimitConstants.ADDORUPDATE_PRODUCTPOINTLIMITS_SUCCESS, productpointlimits } }
    function failure(error, productpointlimits) { return { type: productpointlimitConstants.ADDORUPDATE_PRODUCTPOINTLIMITS_FAILURE, error, productpointlimits } }
}

/**
 * Query object array action
 * @param {*} start 
 * @param {*} rows 
 * @param {*} search 
 * @param {*} sortcolumn 
 * @param {*} sortorder 
 */
function get(start, rows, search, sortcolumn, sortorder) {
    return dispatch => {
        dispatch(request());

        new ProductPointLimitService().query(start,rows,search,sortcolumn,sortorder)
                        .then(
                            productpointlimits => dispatch(success(productpointlimits)),
                            error => {
                                dispatch(failure(error));
                                dispatch(alertActions.error(resources.GET_FAILED + ': ' +error));
                            }
                        );
    };

    function request() { return { type: productpointlimitConstants.GET_PRODUCTPOINTLIMIT_REQUEST } }
    function success(productpointlimits) { return { type: productpointlimitConstants.GET_PRODUCTPOINTLIMIT_SUCCESS, productpointlimits } }
    function failure(error) { return { type: productpointlimitConstants.GET_PRODUCTPOINTLIMIT_FAILURE, error } }
}

/**
 * Query object 
 * @param {*} id
 */
function getById(id) {
    return dispatch => {
        dispatch(request(id));

        new ProductPointLimitService().getById(id)
                        .then(
                            productpointlimit => dispatch(success(productpointlimit)),
                            error => {
                                dispatch(failure(error));
                                dispatch(alertActions.error(resources.GET_FAILED + ': ' + error));
                            }
                        );
    };

    function request(id) { return { type: productpointlimitConstants.GETBYID_PRODUCTPOINTLIMIT_REQUEST, id} }
    function success(productpointlimit) { return { type: productpointlimitConstants.GETBYID_PRODUCTPOINTLIMIT_SUCCESS, productpointlimit } }
    function failure(error) { return { type: productpointlimitConstants.GETBYID_PRODUCTPOINTLIMIT_FAILURE, error } }
}
/**
 * Update
 * @param {*} id
 */
function update(id,data) {
    return dispatch => {
        dispatch(request(data));

        return new ProductPointLimitService().update(id,data)
                        .then(
                            productpointlimit => {
                                dispatch(success(productpointlimit));
                                dispatch(alertActions.success(resources.SAVE_SUCCESS));
                                return productpointlimit;
                            },
                            error => {
                                dispatch(failure(error, data));
                                dispatch(alertActions.error(resources.SAVE_FAILED + ': ' + error));
                                return error;
                            }
                        );
    };

    function request(productpointlimit) { return { type: productpointlimitConstants.UPDATE_PRODUCTPOINTLIMIT_REQUEST, productpointlimit } }
    function success(productpointlimit) { return { type: productpointlimitConstants.UPDATE_PRODUCTPOINTLIMIT_SUCCESS, productpointlimit } }
    function failure(error, productpointlimit) { return { type: productpointlimitConstants.UPDATE_PRODUCTPOINTLIMIT_FAILURE, error, productpointlimit } }
}

/**
 * Delete
 * @param {*} id
 */
function remove(id) {
    return dispatch => {
        dispatch(request());

        return new ProductPointLimitService().remove(id)
                        .then(
                            productpointlimit => {
                                dispatch(success(productpointlimit));
                                dispatch(alertActions.success(resources.DELETE_SUCCESS));
                                return productpointlimit;
                            },
                            error => {
                                dispatch(failure(error));
                                dispatch(alertActions.error(resources.DELETE_FAILED + ': ' + error));
                                return error;
                            }
                        );
    };

    function request() { return { type: productpointlimitConstants.REMOVE_PRODUCTPOINTLIMIT_REQUEST, id } }
    function success() { return { type: productpointlimitConstants.REMOVE_PRODUCTPOINTLIMIT_SUCCESS, id } }
    function failure(error) { return { type: productpointlimitConstants.REMOVE_PRODUCTPOINTLIMIT_FAILURE, error } }
}
